export default {
  THEME: {
    DARK: 'dark',
    LIGHT: 'light',
  },
  ORTHO: {
    LEFT: 'orthoLeft',
    RIGHT: 'orthoRight',
    TOP: 'orthoTop',
    BOTTOM: 'orthoBottom',
    FRONT: 'orthoFront',
    BACK: 'orthoBack',
  },
  CANVAS_UPDATE_TYPES: {
    MATERIAL: 'material',
    MESH: 'mesh',
    CAMERA: 'camera',
    ENVIRONMENT: 'environment',
    TEXTURE: 'texture',
    VIEWPORT: 'viewport',
    PUBLISH: 'publish',
  },
  CANVAS_UPDATE_METHODS: {
    ADD: 'add',
    UPDATE: 'update',
    REMOVE: 'remove',
  },
  RATIOS: {
    square: { name: 'square', label: '1:1', value: 1 },
    broadcast: { name: 'broadcast', label: '4:3', value: 1.33 },
    cinema: { name: 'cinema', label: '16:9', value: 1.77 },
  },
  MESSAGE_TYPES: {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success',
    loading: 'loading',
    deletion: 'deletion',
  },
};